import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Loader(({ node }, load) => {
  const { loadTarget, event } = node.dataset;

  if (!loadTarget) {
    return;
  }

  const eventHandler = (event: Event) => {
    if (!document.body.contains(node)) {
      return;
    }

    const loadTargets = loadTarget.split(',');
    const target = event.target as HTMLElement;
    const loadElement = target.closest('[data-load]') as HTMLElement;

    if (!loadElement) {
      return;
    }

    if (loadTargets.includes(NonNullish(loadElement.dataset.load))) {
      load();
    }
  };

  document.addEventListener(event ?? 'click', eventHandler);
});
